import ssourl from "./core/ssourl.js"
import { getConfig } from "./core/utils.js";

export default class ssourlSeamless extends ssourl {
  endpoint = '';
  vendorId = '';
  platformId = '';
  projectId = '';
  appId = '';
  appSecret = '';
  replyToken = '';
  shortApiId = '';

  constructor(config) {
    super();

    if (config === undefined) throw Error('Seamless login config missing!');

    this.endpoint = config?.endpoint;
    this.vendorId = config?.vendorId;
    this.platformId = config?.platformId;
    this.projectId = config?.projectId;
    this.appId = config?.appId;
    this.appSecret = config?.appSecret;
    this.replyToken = config?.replyToken;
    this.shortApiId = config?.shortApiId;

    super.setEnv();

    if (getConfig("VUE_APP_ENV") == "dev") console.log('=== ssourl::seamless init ===');
  }
}